---
nb:
  marketplace:
    add_now: Legg til
    add_tags: Legg til tagger
    body: Hovedtekst
    card_info: Kortinformasjon
    confirmation: Er du sikker?
    contact_info: Kontaktinformasjon
    filter: Filtrer basert på kategori
    heading: Markedsplass
    image: Bilde
    image_to_large: Bilde må være mindre en 5 MB!
    tags: Tagger
    unexpected_error: En uventet feil oppstod
